module.exports = __webpack_public_path__ + "static/media/cassette-tape.c58064af.svg";